"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecognitionMode = void 0;
/**
 * The Recognition modes
 */
var RecognitionMode;
(function (RecognitionMode) {
    RecognitionMode["Interactive"] = "Interactive";
    RecognitionMode["Dictation"] = "Dictation";
    RecognitionMode["Conversation"] = "Conversation";
    RecognitionMode["None"] = "None";
})(RecognitionMode = exports.RecognitionMode || (exports.RecognitionMode = {}));

//# sourceMappingURL=PhraseDetectionContext.js.map
